<template>
    <div>
        <loading-gdb :propObject="loading"></loading-gdb>
        <div class="title mb-4">
            ProUni 50% <helper-gdb text="Pro Uni 50% - Complementar"/>
        </div>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    v-model="payload.tipo"
                    label="Tipo Execução"
                    :items="[
                        {value: 's', title: 'Visualização'},
                        {value: 'i', title: 'Inserção'},
                    ]"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    :disabled="pletivos.length == 0"
                    @update:modelValue="onChangePletivo"
                    return-object
                    label="Id Perlet"
                    :items="pletivos"
                    item-value="idperlet"
                    item-title="nome"
                    ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-select
                    v-model="payload.parc_final"
                    label="Parcela Final"
                    :items="[6,12]"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="12">
                <v-btn @click="set_insercao_prouni"
                    :disabled="!payload.parc_final || !payload.idperlet"
                    >{{payload.tipo =='s' ? 'Visualizar' : 'Inserir'}}</v-btn>
            </v-col>
            <v-divider class="my-2"></v-divider>
            <v-col cols="12" sm="12">
                {{(logs_insercao||[]).length}} Registro(s)
                <span v-for="l, index in logs_insercao" :key="index">
                    <v-alert color="primary">
                        {{l}}
                    </v-alert>
                </span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: ()=>({
        loading: false,
        pletivos: [],
        scursos: [],
        logs_insercao:[],
        payload: {
            tipo: "s",
            idperlet: null,
            parc_final: null,
        }
    }),
    methods:{
        ...mapActions(['SetProUni50','GetPletivos']),
        async set_insercao_prouni(){
            this.loading = true
            const response = await this.SetProUni50(this.payload)
            if(response.status == 200){
                this.logs_insercao = response.data.result
            }else{
                this.logs_insercao = []
                alert(response.statusText)
            }
            this.loading = false
        },
        async init(){
            const response = await this.GetPletivos( { codtipocurso: [2], top: 10 } )
            if (response.status == 200){
                this.pletivos = response.data
            }
        },
        onChangePletivo(pletivo){
            if (pletivo.codperlet){
                // atualiza idperlet
                this.payload.idperlet = pletivo.idperlet
                // valida final .1
                var fin_dot1 = pletivo.codperlet.indexOf('.1') !== -1 ? 6 : null
                // valida final .2
                var fin_dot2 = pletivo.codperlet.indexOf('.2') !== -1 ? 12 : null
                // valida final sem .1/.2
                var fin = pletivo.codperlet.indexOf('.') === -1 ? 12 : null
                // assume parcela final
                var parcela_final = fin_dot1 | fin_dot2 | fin
                //atualiza parcela final
                this.payload.parc_final =  parcela_final
            }
        }
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading'])
    },
    mounted(){
        this.init()
    }
}
</script>